/**
 * Parser faste artikelsektioner fra Mistral (matcher backend article_template.py).
 */

import { normalizeArticleMarkdown, stripMarkdownInline } from './articleMarkdown'

const SECTION_ORDER = [
  { key: 'introduction', id: 'artikel-introduktion', label: 'Introduktion' },
  { key: 'specs', id: 'artikel-specs', label: 'Specs' },
  { key: 'audience', id: 'artikel-maalgruppe', label: 'Målgruppe' },
  { key: 'priceTier', id: 'artikel-prisleje', label: 'Prisleje' },
]

const HEADING_ALIASES = {
  introduktion: 'introduction',
  intro: 'introduction',
  'kort introduktion': 'introduction',
  specs: 'specs',
  specifikationer: 'specs',
  målgruppe: 'audience',
  'hvem passer det til': 'audience',
  prisleje: 'priceTier',
  prisniveau: 'priceTier',
  prisklasse: 'priceTier',
}

function normalizeHeading(title) {
  const t = stripMarkdownInline(title).toLowerCase().trim()
  return HEADING_ALIASES[t] || null
}

const SECTION_TITLES = ['Introduktion', 'Specs', 'Målgruppe', 'Prisleje']

function parseSections(normalized) {
  const result = {
    introduction: '',
    specs: '',
    audience: '',
    priceTier: '',
  }
  if (!normalized) return result

  const titleAlt = SECTION_TITLES.join('|')
  const chunks = normalized.split(new RegExp(`\\s*##\\s+(${titleAlt})\\s*`, 'i'))
  if (chunks.length > 1) {
    let i = 1
    while (i + 1 < chunks.length) {
      const key = normalizeHeading(chunks[i])
      const body = (chunks[i + 1] || '').trim()
      if (key && body) result[key] = body
      i += 2
    }
    if (Object.values(result).some(Boolean)) return result
  }

  const parts = normalized.split(/\n\n+(?=##\s+)/)
  for (const part of parts) {
    const trimmed = part.trim()
    const m = trimmed.match(/^##\s+(.+?)\n([\s\S]*)$/)
    if (!m) continue
    const key = normalizeHeading(m[1])
    const body = m[2].trim()
    if (key && body) result[key] = body
  }
  return result
}

/**
 * @returns {{ introduction, specs, audience, priceTier, sections, hasContent }}
 */
export function structureProductArticle({ description = '', summary = '' }) {
  const source = description?.trim() ? description : summary
  const normalized = normalizeArticleMarkdown(source)
  const parsed = parseSections(normalized)

  const sections = SECTION_ORDER.map(({ key, id, label }) => ({
    key,
    id,
    label,
    content: parsed[key] || '',
  })).filter((s) => s.content)

  const hasContent = sections.length > 0

  return {
    introduction: parsed.introduction,
    specs: parsed.specs,
    audience: parsed.audience,
    priceTier: parsed.priceTier,
    sections,
    hasContent,
  }
}

export { SECTION_ORDER }
